import { Group, Mesh, Vector3, Curve, TubeGeometry, MeshToonMaterial } from 'three'

class SeaKelp {
  constructor(color) {
    this.group = new Group()
    this.materials = []

    class SecondCurve extends Curve {
      constructor(scale = 1) {
        super()

        this.scale = scale
      }

      getPoint(t, optionalTarget = new Vector3()) {
        const tx = Math.sin(-0.5 * Math.PI * t)
        const ty = t * 3 - 1.5
        const tz = 0

        return optionalTarget.set(tx, ty, tz).multiplyScalar(this.scale)
      }
    }
    const path2 = new SecondCurve(10)

    this.geometry = new TubeGeometry(path2, 10, 2, 3, false)
    this.kelpMaterial = new MeshToonMaterial({ color: 0x1c6812 })
    this.materials.push(this.kelpMaterial)
    this.kelp = new Mesh(this.geometry, this.kelpMaterial)
    this.kelp.scale.set(0.1, 0.1, 0.1)
    this.kelp.position.z = 2 + Math.random()

    this.group.add(this.kelp)
    this.kelp.rotation.set(Math.PI / 2, 0, 0)
  }
}

export default SeaKelp
